import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./NavLogs.scss";
import { navLogShape, resolutionPropType } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { sendTagOnNavlogNext, sendTagOnNavlogPrevious } from "app/utils/analytics";
import { NAVLOGS_SHOW_SLIDES_NUMBER } from "app/constants";
import Swiper from "react-id-swiper";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import NavLogProductCard from "app/pages/Listing/NavLogs/NavLogProductCard";
import appGlobalsContext from "app/AppGlobalsContext";
import { ArrowRightIcon, ArrowLeftIcon } from "app/icons/navigation";

const PLACEHOLDER_ID = "navlog-placeholder";

const NavLogs = ({ navLogs = [], resolution }) => {
	const [swiper, setSwiper] = useState(null);
	const [isBeginning, setIsBeginning] = useState(true);
	const [isEnd, setIsEnd] = useState(false);

	const { publicPath = "" } = useContext(appGlobalsContext);

	const updateSwiper = swiper => {
		setSwiper(swiper);
	};

	const slidePrev = () => {
		swiper.slidePrev();
	};

	const slideNext = () => {
		swiper.slideNext();
	};

	const slidePrevTransitionEnd = () => {
		sendTagOnNavlogPrevious();
	};

	const isDesktop =
		resolution === RESOLUTION.LARGE ||
		resolution === RESOLUTION.XLARGE ||
		resolution === RESOLUTION.MEDIUM;

	const showArrows = isDesktop && navLogs.length > 3;

	const swiperParams = {
		shouldSwiperUpdate: true,
		getSwiper: updateSwiper,
		slidesPerView: NAVLOGS_SHOW_SLIDES_NUMBER[resolution],
		spaceBetween: 24,
		centeredSlides: !isDesktop && navLogs.length === 1,
		on: {
			slidePrevTransitionEnd: slidePrevTransitionEnd,
		},
	};

	// si on affiche moins de 3 produits, alors on complete avec des placeholders jusqu'à 3
	if (isDesktop) {
		if (navLogs.length === 1) {
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-1`,
				url: `${publicPath}/picture/beach-placeholder.svg`,
			});
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-2`,
				url: `${publicPath}/picture/city-placeholder.svg`,
			});
		} else if (navLogs.length === 2) {
			navLogs.push({
				uri: PLACEHOLDER_ID,
				id: `${PLACEHOLDER_ID}-1`,
				url: `${publicPath}/picture/beach-placeholder.svg`,
			});
		}
	}

	useEffect(() => {
		if (swiper) {
			swiper.on("slideChangeTransitionEnd", () => {
				const isBeginning = swiper?.isBeginning;
				const isEnd = swiper?.isEnd;

				setIsBeginning(isBeginning);

				setIsEnd(isEnd);
			});

			swiper.on("slideNextTransitionEnd", () => {
				const navigateToSlideIndex = Math.round(
					NAVLOGS_SHOW_SLIDES_NUMBER[resolution] + swiper.activeIndex - 1
				);

				sendTagOnNavlogNext({
					...navLogs[navigateToSlideIndex],
					lastSeenProductType: navLogs[navigateToSlideIndex]?.quotationURL
						? "quote"
						: "product",
				});
			});
		}

		return () => {
			if (swiper) {
				swiper.off("slideChangeTransitionEnd");
				swiper.off("slideNextTransitionEnd");
			}
		};
	}, [swiper]);

	return (
		navLogs.length >= 1 && (
			<div className="navlogs">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL3}
					variantMD={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="navlogs__title"
					component="h2"
				>
					<FormattedMessage id="listing.last.viewed.trip" />
				</Typography>

				<div className="navlogs__carousel">
					<Swiper {...swiperParams}>
						{navLogs.map(navLog => {
							if (navLog.uri === PLACEHOLDER_ID) {
								return (
									<div key={navLog.id} className="navlogs__placeholder">
										<div
											style={{
												backgroundImage: `url("${navLog.url}")`,
											}}
											className="navlogs__placeholder-picture"
										/>
										<div className="navlogs__placeholder-text">
											<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold>
												<FormattedMessage id="general.upcoming.trip.label" />
											</Typography>
										</div>
									</div>
								);
							}

							return (
								<div key={navLog.id}>
									<NavLogProductCard
										{...navLog}
										photo={navLog.photos && navLog.photos[0]}
										resolution={resolution}
									/>
									{/*{productCardDesignValue === "new-price-left" ||*/}
									{/*productCardDesignValue === "new-price-right" ? (*/}
									{/*	<NavLogProductCard*/}
									{/*		{...navLog}*/}
									{/*		photo={navLog.photos && navLog.photos[0]}*/}
									{/*		resolution={resolution}*/}
									{/*	/>*/}
									{/*) : (*/}
									{/*	<NavLogProduct*/}
									{/*		{...navLog}*/}
									{/*		photo={navLog.photos && navLog.photos[0]}*/}
									{/*		resolution={resolution}*/}
									{/*	/>*/}
									{/*)}*/}
								</div>
							);
						})}
					</Swiper>
					<div className="navlogs__carousel__button navlogs__carousel__button--next">
						{showArrows && !isEnd && swiper && (
							<ArrowRightIcon
								className="icon icon-navigation icon--next flip-if-rlt"
								onClick={slideNext}
							/>
						)}
					</div>
					<div className="navlogs__carousel__button navlogs__carousel__button--previous">
						{showArrows && !isBeginning && swiper && (
							<ArrowLeftIcon
								className="icon icon-navigation icon--previous flip-if-rlt"
								onClick={slidePrev}
							/>
						)}
					</div>
				</div>
			</div>
		)
	);
};

NavLogs.propTypes = {
	navLogs: PropTypes.arrayOf(navLogShape),
	resolution: resolutionPropType,
};

export default NavLogs;
